/**
 * ===================================================================================================
 * keywordConstants.js - 채팅 메시지 분석에 사용되는 키워드 상수 정의 파일
 * ===================================================================================================
 *
 * 📍 위치: 프론트엔드 > client/src/hooks/useChat/constants/keywordConstants.js
 *
 * 🎯 주요 기능:
 *    - 사용자의 채팅 메시지에서 특정 의도(예: 전체 삭제, 일정 관련)를 파악하기 위한 키워드 목록을 정의합니다.
 *    - `DELETE_ALL_KEYWORDS`: "전부", "모든"과 같이 전체 삭제를 의미하는 키워드들을 포함합니다.
 *    - `SCHEDULE_KEYWORDS`: "일정", "약속"과 같이 일정과 관련된 키워드들을 포함합니다.
 *
 * 🔗 연결된 파일:
 *    - client/src/hooks/useChat/handlers/createIntentHandlers.js - 키워드를 사용하여 사용자 의도를 해석하는 핸들러 파일
 *    - client/src/hooks/useChat/handlers/enhancedIntentHandlers.js - 강화된 키워드 분석에 사용될 수 있습니다.
 *
 * 💡 UI 위치:
 *    - 직접적인 UI 요소는 없지만, 채팅 입력 시 사용자 의도 파악 로직에 간접적으로 사용됩니다.
 *
 * ✏️ 수정 가이드:
 *    - 이 파일을 수정하면: 채팅 메시지에서 특정 의도를 파악하는 로직의 기준이 변경됩니다.
 *    - 새로운 키워드 추가: 해당 키워드 배열에 새로운 문자열을 추가합니다.
 *    - 기존 키워드 수정/제거: 배열에서 해당 문자열을 수정하거나 제거합니다.
 *
 * 📝 참고사항:
 *    - 키워드 목록은 사용자의 자연어 명령을 보다 정확하게 이해하는 데 도움을 줍니다.
 *    - 키워드 추가/수정 시, 관련 핸들러 로직과의 일관성을 유지하는 것이 중요합니다.
 *
 * ===================================================================================================
 */

// 전체 삭제 키워드
export const DELETE_ALL_KEYWORDS = ['전부', '모든', '모두', '다', '전체'];

// 일정 키워드
export const SCHEDULE_KEYWORDS = ['일정', '약속', '미팅', '회의', '모임', '전체', '전부', '모든', '모두'];
